import $, { error } from 'jquery';
import Constants from 'root/constants';
import Util from 'root/module/util';
import SVG from 'root/module/svg_icon';
import Form from 'root/module/form';
import Router from 'root/router';
import Cache from 'root/cache';
import View from 'view/base';
import confetti from 'canvas-confetti';

import jui from 'root/lib/jquery-ui.min';

const integrations = {
    jira: {
        text: 'Jira',
        icon: '/image/jira_small.png',
        website: 'https://yourcompany.atlassian.net'
    },
    clickup: {
        text: 'ClickUp',
        icon: '/image/clickup_small.png',
        website: 'https://app.clickup.com/'
    },
    asana: {
        text: 'Asana',
        icon: '/image/asana_small.png',
        website: 'https://app.asana.com/'
    },
    notion: {
        text: 'Notion',
        icon: '/image/notion_small.png',
        website: 'https://www.notion.so/'
    },
    teamwork: {
        text: 'Teamwork',
        icon: '/image/teamwork_small.png',
        website: 'https://yourcompany.teamwork.com/'
    },
    trello: {
        text: 'Trello',
        icon: '/image/trello_small.png',
        website: 'https://trello.com/'
    },
    linear: {
        text: 'Linear',
        icon: '/image/linear_small.png',
        website: 'https://linear.app/'
    },
    basecamp: {
        text: 'Basecamp',
        icon: '/image/basecamp_small.png',
        website: 'https://3.basecamp.com/'
    },
    monday: {
        text: 'Monday',
        icon: '/image/monday_small.png',
        website: 'https://monday.com/'
    },
    wrike: {
        text: 'Wrike',
        icon: '/image/wrike_small.png',
        website: 'https://www.wrike.com/'
    },
    github: {
        text: 'GitHub',
        icon: '/image/github_small.png',
        website: 'https://github.com/'
    },
    gitlab: {
        text: 'GitLab',
        icon: '/image/gitlab_small.png',
        website: 'https://gitlab.com/'
    },
    azure_devops: {
        text: 'DevOps',
        icon: '/image/azure_devops_small.png',
        website: 'https://dev.azure.com/'
    },
    webhook: {
        text: 'Webhook',
        icon: '/image/webhook_small.png',
        website: 'https://yourwebhook'
    }
};

const statuses = [
    {
        name: 'Open',
        colour: '#6040FF',
        selected: true
    },
    {
        name: 'In Progress',
        colour: '#4080FF',
        selected: true
    },
    {
        name: 'In QA',
        colour: '#FF4060',
        selected: true
    },
    {
        name: 'To Do',
        colour: '#FF8040',
        selected: false
    },
    {
        name: 'Backlog',
        colour: '#93A9BE',
        selected: false
    },
    {
        name: 'Resolved',
        colour: '#00C080',
        selected: true
    }
];

export { integrations };

export default View.extend({
    step: 1,

    widget_colour: '#6040FF',

    events: {
        'input form input'              : 'onCheckForm',

        'click .setup-back'             : 'onGoBack',
        'click .setup-next'             : 'onGoNext',
        'click .setup-submit'           : 'onSubmitSetup',

        // step 1
        'submit .form-company'          : 'onSubmitCompany',
        'input [name="project_url"]'    : 'onChangeProjectUrl',

        // step 2
        'click .workflow-option'        : 'onSelectWorkflow',

        // step 3
        'mouseenter .integration-tool'  : 'onPreviewIntegrationTool',
        'mouseleave .integration-tool'  : 'onExitPreviewIntegrationTool',
        'click .integration-tool'       : 'onSelectIntegrationTool',

        // step 4
        'mouseenter .notification-tool' : 'onPreviewNotificationTool',
        'mouseleave .notification-tool' : 'onExitPreviewNotificationTool',
        'click .notification-tool'      : 'onSelectNotificationTool',

        // step 5
        'input [name="invite_email"]'   : 'onCheckInviteEmail',

        // step 6
        'mouseenter .widget-colour-palette' : 'onPreviewWidgetColour',
        'mouseleave .widget-colour-palette' : 'onExitPreviewWidgetColour',
        'click .widget-colour-palette'      : 'onSelectWidgetColour'
    },

    dom_handlers: {
        onCheckForm: function(e) {
            this.checkForm();
        },

        onGoBack: function(e) {
            this.goToStep(this.step - 1);
        },

        onGoNext: function(e) {
            this.goToStep(this.step + 1);
        },

        onSubmitSetup: function(e) {
            var form_data = Form.getData(this.$el);

            // step 2: workflow
            var workflow_data = this.$el.find('.workflow-option.selected').map((index, ele) => {
                return {
                    name: $(ele).data('val'),
                    colour: statuses.find((status) => status.name === $(ele).data('val')).colour
                };
            }).get();

            // step 5: invite
            var invite_emails = this.$el.find('[name="invite_email"]').map((index, ele) => {
                return Util.isValidEmail($(ele).val()) ? $(ele).val() : null;
            }).get();

            this.submit(
                form_data.company,
                form_data.project_url,
                'My first project',
                'wt101',
                workflow_data,
                this.integration_type,
                this.notification_type,
                this.widget_colour,
                invite_emails
            );

            this.$el.find('.setup-submit').addClass('loading').prop('disabled', true);
        },

        onSubmitCompany: function(e) {
            this.goToStep(2);
        },

        onChangeProjectUrl: function(e) {
            var project_url = Form.getData(this.$el).project_url;
            this.$el.find('.widget-preview .address-bar').text('https://' + project_url);

            this.$el.find('.widget-launcher').toggleClass('active', project_url !== '');
        },

        onPreviewIntegrationTool: function(e) {
            var integration_type = $(e.currentTarget).data('val');

            if (!integration_type) {
                return;
            }

            this.$el.find('.integration-favicon').attr('src', integrations[integration_type].icon).show();
            this.$el.find('.integration-website').text(integrations[integration_type].website);
            this.$el.find('.integration-selected').text(integrations[integration_type].text);
        },

        onExitPreviewIntegrationTool: function(e) {
            if (this.integration_type) {
                this.$el.find('.integration-favicon').attr('src', integrations[this.integration_type].icon).show();
                this.$el.find('.integration-website').text(integrations[this.integration_type].website);
                this.$el.find('.integration-selected').text(integrations[this.integration_type].text);
            }
        },

        onSelectIntegrationTool: function(e) {
            this.integration_type = $(e.currentTarget).data('val');

            $(e.currentTarget).addClass('selected').siblings().removeClass('selected');

            this.goToStep(4);
        },

        onSelectWorkflow: function(e) {
            if (this.$el.find('.workflow-option.selected').length <= 2 && $(e.currentTarget).hasClass('selected')) {
                return;
            }

            $(e.currentTarget).toggleClass('selected');

            this.renderWorkflowPreview();
        },

        onPreviewNotificationTool: function(e) {
            var notification_type = $(e.currentTarget).data('val');

            this.$el.find('.slack-preview').toggleClass('selected', notification_type === 'slack');
            this.$el.find('.teams-preview').toggleClass('selected', notification_type === 'teams');
        },

        onExitPreviewNotificationTool: function(e) {
            this.$el.find('.slack-preview').toggleClass('selected', this.notification_type === 'slack');
            this.$el.find('.teams-preview').toggleClass('selected', this.notification_type === 'teams');
        },

        onSelectNotificationTool: function(e) {
            this.notification_type = $(e.currentTarget).data('val');

            this.$el.find('.slack-preview').toggleClass('selected', this.notification_type === 'slack');
            this.$el.find('.teams-preview').toggleClass('selected', this.notification_type === 'teams');

            $(e.currentTarget).addClass('selected').siblings().removeClass('selected');

            this.goToStep(5);
        },

        onCheckInviteEmail: function(e) {
            clearTimeout(this.invite_timeout);

            this.invite_timeout = setTimeout(() => {
                var email = $(e.currentTarget).val();
                var index = $(e.currentTarget).index();

                if (Util.isValidEmail(email)) {
                    this.$el.find('.user-preview').eq(index + 1).find('.user-img-48').css('background-image', 'url(' + Util.gravatar(email, 48) + ')');
                } else {
                    this.$el.find('.user-preview').eq(index + 1).find('.user-img-48').css('background-image', '');
                }
            }, 200);
        },

        onPreviewWidgetColour: function(e) {
            var colour = $(e.currentTarget).css('background-color');

            this.$el.find('.widget-header').css('background-color', colour);
            this.$el.find('.widget-form button').css('background-color', colour);
            this.$el.find('.widget-launcher').css('background-color', colour);
        },

        onExitPreviewWidgetColour: function(e) {
            if (this.widget_colour) {
                this.$el.find('.widget-header').css('background-color', this.widget_colour);
                this.$el.find('.widget-form button').css('background-color', this.widget_colour);
                this.$el.find('.widget-launcher').css('background-color', this.widget_colour);
            }
        },

        onSelectWidgetColour: function(e) {
            var colour = $(e.currentTarget).data('val');

            this.$el.find('.widget-header').css('background-color', colour);
            this.$el.find('.widget-form button').css('background-color', colour);
            this.$el.find('.widget-launcher').css('background-color', colour);

            $(e.currentTarget).addClass('selected').siblings().removeClass('selected');

            this.widget_colour = colour;
        }
    },

    submit: function(company, project_url, project_name, template_code, workflow_data, integration, notification, widget_colour, invite_emails) {
        Cache.app.request({
            action:  'account/completeSetup',
            data: {
                company: company,
                integration: integration,
                notification: notification
            },
            success: () => {
                Cache.app.request({
                    action:  'project/create',
                    data:    {
                        name              : project_name,
                        project_key       : 'PROJ1',
                        template_code     : template_code,
                        domains           : [project_url],
                        create_demo_data  : true,
                        workflow_template : workflow_data,
                        widget_colour     : widget_colour
                    },
                    success: (response) => {
                        var landing_page = '/' + response.project.project_key + '/feedback/?onboarding=1';

                        if (invite_emails && invite_emails.length) {
                            Cache.app.request({
                                action: 'account/inviteUser',
                                data: {
                                    emails: invite_emails,
                                    project_ids: response.project.id,
                                    role: Constants.ASSIGNEE
                                },
                                complete: () => {
                                    window.location = landing_page;
                                },
                                error: () => {
                                    // ignore error
                                }
                            });
                        } else {
                            window.location = landing_page;
                        }
                    }
                });
            },
            complete: () => {
                this.$el.find('.setup-submit').removeClass('loading').prop('disabled', false);
            }
        });
    },

    goToStep: function(step) {
        var steps = ['', 'workflow', 'integration', 'notification', 'invite', 'widget'];
        var step_name = steps[step - 1];

        // track page view
        if (step_name) {
            Router.addQueryString('s', step_name);
        } else {
            Router.removeQueryString('s');
        }

        this.step = step;

        this.$el.find('.preview-scroller').attr('data-step', step);

        this.$el.find('.setup-step').hide();
        this.$el.find('.setup-step[data-val="' + step + '"]')
            .show()
            .find('input:first').focus();

        this.$el.find('.setup-progress span').css('width', step / 6 * 100 + '%');
    },

    checkForm: function() {
        var form_data = Form.getData(this.$el);

        this.$el.find('.form-company button:submit').prop('disabled', !form_data.company || !form_data.project_url);
    },

    onPageReady: function() {
        if (Cache.project.length) {
            Router.navigate('/project/', {trigger: true});
        }

        this.$el.find('input:first').focus();

        this.makeDraggable();
    },

    makeDraggable: function() {
        this.$el.find('.kanban-example').each((index, ele) => {
            $(ele).draggable({
                addClasses: false,
                revert: 'invalid',
                scroll: true,
                containment: $(ele).closest('.kanban-preview'),
            });
        });

        this.$el.find('.kanban-preview > div').droppable({
            addClasses: false,
            accept: '.kanban-example',
            drop: function(e, ui) {
                var column_from = ui.draggable.closest('.kanban-column');

                $(this).append(ui.draggable);
                $(this).
                    find('.example-placeholder').not('.example-placeholder-sticky')
                    .appendTo(column_from);

                ui.draggable.css({
                    left: 0,
                    top: 0
                });

                if ($(this).find('.status-name').text() === 'Resolved') {
                    confetti({
                        particleCount: 100,
                        spread: 70,
                        origin: {
                            x: (ui.offset.left + (ui.draggable.width() / 2)) / window.innerWidth,
                            y: (ui.offset.top + (ui.draggable.height() / 2)) / window.innerHeight
                        }
                    });
                }
            }
        });
    },

    renderKanbanColumn: function(index, status) {
        return '' +
        '<div class="kanban-column">' +
            '<div class="kanban-status">' +
            '<span class="workflow-option-colour" style="background-color:' + status.colour + ';"></span>' +
            '<span class="status-name">' + status.name + '</span>' +
        '</div>' +
            (index === 0 ?
            '<div class="kanban-example">' +
                '<div class="margin-bottom-8">Bug #1</div>' +
                '<div class="example-placeholder example-placeholder-sticky"></div>' +
                '<div class="example-placeholder example-placeholder-sticky"></div>' +
                '<div>' +
                    '<i class="fa-solid fa-comment-lines"></i>' +
                    '<i class="fa-solid fa-circle-play"></i>' +
                    '<i class="fa-solid fa-draw-square"></i>' +
                '</div>' +
            '</div>' :
            '<div class="example-placeholder" style="width:40%;"></div>' +
            '<div class="example-placeholder"></div>' +
            '<div class="example-placeholder"></div>' +
            '<div class="example-placeholder"></div>') +
        '</div>';
    },

    renderWorkflowPreview: function() {
        var html = '';

        this.$el.find('.workflow-option.selected').each((index, ele) => {
            var workflow_name = $(ele).data('val');
            var status = statuses.find((status) => status.name === workflow_name);

            html += this.renderKanbanColumn(index, status);
        });

        this.$el.find('.kanban-preview').html(html);

        this.makeDraggable();
    },

    render: function() {
        var email_domain = Cache.getRealUser().get('email').split('@')[1];

        var step_welcome =
        '<div class="heading-large">Welcome to Userback 👋</div>' +
        '<div class="heading-desc">Let\'s set up your account</div>' +
        '<form class="form-fluid form-company">' +
            '<div class="row">' +
                '<div class="field-label font-weight-semibold">Company name</div>' +
                '<input class="solid medium" name="company" type="text" maxlength="100" placeholder="My company" required>' +
            '</div>' +
            '<div class="divider-12"></div>' +

            '<div class="row">' +
                '<div class="field-label font-weight-semibold">Where will you be collecting feedback?</div>' +
                '<div class="input-domain">' +
                    '<input type="text" name="project_url" placeholder="myapp.com">' +
                '</div>' +
            '</div>' +

            '<div class="divider-16"></div>' +
            '<button type="submit" class="primary medium fluid" disabled>Continue</button>' +
        '</form>';

        var step_widget =
        '<div class="heading-large">Customize your widget</div>' +
        '<div class="heading-desc">Choose a color for your feedback widget</div>' +
        '<div class="overflow-hidden">' +
            ['#6040FF', '#4080FF', '#30B0D0', '#6080A0', '#00C080', '#FFC040', '#FF8040', '#FF4060'].map((colour, index) => {
                return '' +
                '<div data-val="' + colour + '" class="widget-colour-palette' + (colour === this.widget_colour ? ' selected' : '') + '" style="background-color:' + colour + ';"></div>';
            }).join('') +
        '</div>' +
        '<div class="text-info text-medium">Edit other widget settings later</div>' +
        '<div class="margin-top-48 flex-between">' +
            '<button type="button" class="small tertiary min setup-back"><i class="fa-solid fa-angle-left text-icon"></i> Back</button>' +
            '<button type="button" class="small primary min setup-next">Next <i class="fa-solid fa-angle-right"></i></button>' +
        '</div>';

        var step_integration =
        '<div class="heading-large">Select your existing tool</div>' +
        '<div class="heading-desc">Automatically sync data between Userback and your project management tool</div>' +
        '<div class="grid-4-4-4 grid-gap-8">' +
            Object.keys(integrations).map((integration_type) => {
                return '' +
                '<div class="integration-tool" data-val="' + integration_type + '">' +
                    '<img src="' + integrations[integration_type].icon + '">' + integrations[integration_type].text +
                '</div>';
            }).join('') +
        '</div>' +
        '<div class="margin-top-48 flex-between">' +
            '<button type="button" class="small tertiary min setup-back"><i class="fa-solid fa-angle-left text-icon"></i> Back</button>' +
            '<button type="button" class="small primary min setup-next">Next <i class="fa-solid fa-angle-right"></i></button>' +
        '</div>';

        var step_notification =
        '<div class="heading-large">Select your notification tool</div>' +
        '<div class="heading-desc">Get real-time alerts on new feedback and important updates</div>' +
        '<div class="grid-6-6 grid-gap-8">' +
            '<div class="notification-tool" data-val="slack"><img src="/image/slack_small.png">Slack</div>' +
            '<div class="notification-tool" data-val="teams"><img src="/image/teams_small.png">Teams</div>' +
        '</div>' +
        '<div class="margin-top-48 flex-between">' +
            '<button type="button" class="small tertiary min setup-back"><i class="fa-solid fa-angle-left text-icon"></i> Back</button>' +
            '<button type="button" class="small primary min setup-next">Next <i class="fa-solid fa-angle-right"></i></button>' +
        '</div>';

        var step_invite =
        '<div class="heading-large">Invite users</div>' +
        '<div class="heading-desc">Have your product manager, support team and developers see, reply and resolve feedback</div>' +
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label font-weight-semibold">Emails</div>' +
                '<div>' +
                    '<input class="solid medium margin-bottom-8" name="invite_email" type="email" placeholder="user1@' + email_domain + '">' +
                    '<input class="solid medium margin-bottom-8" name="invite_email" type="email" placeholder="user2@' + email_domain + '">' +
                    '<input class="solid medium margin-bottom-8" name="invite_email" type="email" placeholder="user3@' + email_domain + '">' +
                    '<input class="solid medium" name="invite_email" type="email" placeholder="user4@' + email_domain + '">' +
                '</div>' +
            '</div>' +
        '</form>' +

        '<div class="margin-top-48 flex-between">' +
            '<button type="button" class="small tertiary min setup-back"><i class="fa-solid fa-angle-left text-icon"></i> Back</button>' +
            '<button type="button" class="small primary min setup-next">Next <i class="fa-solid fa-angle-right"></i></button>' +
        '</div>';

        var step_workflow =
        '<div class="heading-large">Customize your workflow</div>' +
        '<div class="heading-desc">Choose the status you use to manage feedback</div>' +
        '<div>' +
            statuses.map((status) => {
                return '' +
                '<div class="workflow-option' + (status.selected ? ' selected' : '') + '" data-val="' + status.name + '">' +
                    '<div class="workflow-option-colour" style="background-color:' + status.colour + ';"></div>' +
                    '<div>' + status.name + '</div>' +
                '</div>';
            }).join('') +
        '</div>' +
        '<div class="text-info text-medium margin-top-8">Edit other workflow settings later</div>' +
        '<div class="margin-top-48 flex-between">' +
            '<button type="button" class="small tertiary min setup-back"><i class="fa-solid fa-angle-left"></i> Back</button>' +
            '<button type="button" class="small primary min setup-submit">Finish <i class="fa-solid fa-arrow-right"></i></button>' +
        '</div>';

        var preview_welcome =
        '<div class="widget-preview">' +
            '<div class="address-bar">https://</div>' +
            '<div class="widget-launcher">Feedback</div>' +
        '</div>';

        var preview_widget =
        '<div class="widget-form">' +
            '<div class="widget-header">' +
                SVG.widget_pointer +
                '<div>Hi ' + Cache.getRealUser().escape('name') + ', I\'m your AI assisted widget 🤖</div>' +
            '</div>' +
            '<div class="widget-body">' +
                '<div class="example-placeholder"></div>' +
                '<div class="example-placeholder"></div>' +
                '<textarea class="solid"></textarea>' +
                '<div class="widget-tools">' +
                    '<div><i class="text-icon fa-solid fa-draw-square"></i> Screenshot</div>' +
                    '<div><i class="text-icon fa-solid fa-paperclip"></i> Upload</div>' +
                '</div>' +
                '<div class="flex-end">' +
                    '<button type="button" class="primary small min">Submit</button>' +
                '</div>' +
            '</div>' +
        '</div>';

        var preview_integration =
        '<div class="integration-preview">' +
            '<div class="address-bar">' +
                '<img class="integration-favicon" style="display:none;">' +
                '<span class="integration-website">https://</span>' +
            '</div>' +
            '<div class="browser-body browser-body-split">' +
                '<div>' +
                    '<div class="task-title">Bug #1</div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder" style="width:40%;"></div>' +
                    '<div class="task-screenshot"><i class="fa-solid fa-play-circle"></i></div>' +
                '</div>' +
                '<div>' +
                    '<div class="task-title">&nbsp;</div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                '</div>' +
            '</div>' +
        '</div>';

        var preview_notification =
        '<div class="notification-preview">' +
            '<div class="email-preview">' +
                '<div>' +
                    '<div class="email-logo">' +
                        '<img src="/image/gmail_logo.png">Inbox' +
                    '</div>' +
                    '<div class="email-subject">' +
                        '<div><input type="checkbox"><label></label></div>' +
                        '<div>' +
                            '<div><div class="example-placeholder"></div></div>' +
                            '<div class="example-placeholder"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="email-subject selected">' +
                        '<div><input type="checkbox"><label></label></div>' +
                        '<div>' +
                            '<div>New feedback</div>' +
                            '<div class="example-placeholder margin-top-4"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="email-subject">' +
                        '<div><input type="checkbox"><label></label></div>' +
                        '<div>' +
                            '<div><div class="example-placeholder"></div></div>' +
                            '<div class="example-placeholder"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="email-subject">' +
                        '<div><input type="checkbox"><label></label></div>' +
                        '<div>' +
                            '<div><div class="example-placeholder"></div></div>' +
                            '<div class="example-placeholder"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="email-subject">' +
                        '<div><input type="checkbox"><label></label></div>' +
                        '<div>' +
                            '<div><div class="example-placeholder"></div></div>' +
                            '<div class="example-placeholder"></div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div>' +
                    '<div class="task-title task-title-large">Bug #1</div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder" style="width:40%;"></div>' +
                    '<div class="task-screenshot"><i class="fa-solid fa-play-circle"></i></div>' +
                '</div>' +
            '</div>' +
            '<div class="slack-preview">' +
                '<div>' +
                    '<div class="channel-name"><img src="/image/slack_small.png"> user-feedback</div>' +
                    '<div class="channel-placeholder"></div>' +
                    '<div class="channel-placeholder"></div>' +
                    '<div class="channel-placeholder"></div>' +
                '</div>' +
                '<div>' +
                    '<div class="task-title task-title-large">New Feedback: Bug #1</div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder" style="width:40%;"></div>' +
                    '<div class="task-screenshot"><i class="fa-solid fa-play-circle"></i></div>' +

                    '<div class="flex-start margin-top-12">' +
                        '<button class="tiny tertiary margin-right-8">Reply</button>' +
                        '<button class="tiny tertiary margin-right-8">Assign</button>' +
                        '<button class="tiny tertiary">Resolve</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="teams-preview">' +
                '<div>' +
                    '<div class="channel-name"><img src="/image/teams_small.png"> user-feedback</div>' +
                    '<div class="channel-placeholder"></div>' +
                    '<div class="channel-placeholder"></div>' +
                    '<div class="channel-placeholder"></div>' +
                '</div>' +
                '<div>' +
                    '<div class="task-title task-title-large">New Feedback: Bug #1</div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder"></div>' +
                    '<div class="example-placeholder" style="width:40%;"></div>' +
                    '<div class="task-screenshot"><i class="fa-solid fa-play-circle"></i></div>' +

                    '<div class="flex-start margin-top-12">' +
                        '<button class="tiny tertiary margin-right-8">Reply</button>' +
                        '<button class="tiny tertiary margin-right-8">Assign</button>' +
                        '<button class="tiny tertiary">Resolve</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        var preview_invite =
        '<div class="invite-preview">' +
            '<div class="address-bar">' +
                '<span>https://app.userback.io</span>' +
            '</div>' +
            '<div class="browser-body browser-body-full">' +
                '<div class="task-title">My Team</div>' +
                '<div>' +
                    '<div class="user-preview">' +
                        '<div class="user-img-48" style="background-image:url(\'' + Util.gravatar(Cache.getRealUser().get('email'), 48, Cache.getRealUser().get('name')) + '\');"></div>' +
                        '<div>' +
                            '<div class="margin-bottom-8">' + Cache.getRealUser().escape('name') + '</div>' +
                            '<div class="example-placeholder" style="width:60%;"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="user-preview">' +
                        '<div class="user-img-48"></div>' +
                        '<div>' +
                            '<div class="example-placeholder margin-top-8" style="width:100px;"></div>' +
                            '<div class="example-placeholder" style="width:60%;"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="user-preview">' +
                        '<div class="user-img-48"></div>' +
                        '<div>' +
                            '<div class="example-placeholder margin-top-8" style="width:100px;"></div>' +
                            '<div class="example-placeholder" style="width:60%;"></div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="user-preview">' +
                        '<div class="user-img-48"></div>' +
                        '<div>' +
                            '<div class="example-placeholder margin-top-8" style="width:100px;"></div>' +
                            '<div class="example-placeholder" style="width:60%;"></div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';

        var preview_workflow =
        '<div class="kanban-preview">' +
            statuses.map((status, index) => {
                if (!status.selected) {
                    return '';
                } else {
                    return this.renderKanbanColumn(index, status);
                }
            }).join('') +
        '</div>';

        var content =
        '<div class="logo"><a href="https://userback.io" target="_blank" rel="noopener">' + SVG.logo + '</a></div>' +
        '<div class="region-setup">' +
            // left
            '<div>' +
                '<div>' +
                    '<div class="setup-step" data-val="1">' +
                        step_welcome +
                    '</div>' +

                    '<div class="setup-step" data-val="2">' +
                        step_widget +
                    '</div>' +

                    '<div class="setup-step" data-val="3">' +
                        step_integration +
                    '</div>' +

                    '<div class="setup-step" data-val="4">' +
                        step_notification +
                    '</div>' +

                    '<div class="setup-step" data-val="5">' +
                        step_invite +
                    '</div>' +

                    '<div class="setup-step" data-val="6">' +
                        step_workflow +
                    '</div>' +
                '</div>' +
            '</div>' +

            // right
            '<div>' +
                '<div class="account-setup-flowchart">' +
                    '<div class="preview-scroller" data-step="1">' +
                        '<div class="preview-step" data-val="1">' +
                            preview_welcome +
                        '</div>' +

                        '<div class="preview-step" data-val="2">' +
                            preview_widget +
                        '</div>' +

                        '<div class="preview-step" data-val="3">' +
                            preview_integration +
                        '</div>' +

                        '<div class="preview-step" data-val="4">' +
                            preview_notification +
                        '</div>' +

                        '<div class="preview-step" data-val="5">' +
                            preview_invite +
                        '</div>' +

                        '<div class="preview-step" data-val="6">' +
                            preview_workflow +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<div class="setup-progress"><span style="width:16.7%;"></span></div>';

        this.$el.html(content);

        return this;
    }
});